import axios from "axios";
import { useSelector, useDispatch } from 'react-redux'

import { 
    doLogout,
} from "src/reducers/reducer_core";

// eslint-disable-next-line import/no-anonymous-default-export
export default (store) => {
    axios.interceptors.request.use(async (request) => {
        request.withCredentials = true
        return request
    })

    axios.interceptors.response.use(
        function (response) {
            return response
        },
        function (error) {
            if (error.response) {
                if (error?.response?.status === 401) {
                    store.dispatch(doLogout())
                }
            }

            return Promise.reject(error)
        },
    )
}
